
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/our-story",
      function () {
        return require("private-next-pages/[region]/[lang]/our-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/our-story"])
      });
    }
  